import { ComponentRegistry } from './component-registry';
import { OnChange } from './on-change.interface';
import { OnDestroy } from './on-destroy.interface';
import { OnInit } from './on-init.interface';

export abstract class BaseComponent<
  TChild extends BaseComponent<TChild>
> extends HTMLElement {
  protected _root: ShadowRoot = this.attachShadow({ mode: 'open' });
  protected initialized = false;

  constructor(private component: CustomElementConstructor) {
    super();

    this._render();
  }

  private async _render() {
    const styles = ComponentRegistry.getStylesheet(this.component);
    const elements = await this.createInitialComponent();

    if (styles !== undefined) {
      this._root.appendChild(styles);
    }

    if (Array.isArray(elements)) {
      for (const element of elements) {
        this._root.appendChild(element);
      }
    } else {
      this._root.appendChild(elements);
    }

    this.initialized = true;

    if (typeof (this as unknown as OnInit)?.onInit === 'function') {
      await (this as unknown as OnInit)?.onInit();
    }
  }

  abstract createInitialComponent(): Promise<HTMLElement | HTMLElement[]>;

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (
      this.initialized &&
      typeof (this as unknown as OnChange)?.onChange === 'function'
    ) {
      (this as unknown as OnChange)?.onChange(name, oldValue, newValue);
    }
  }

  remove(): void {
    if (typeof (this as unknown as OnDestroy)?.onDestroy === 'function') {
      (this as unknown as OnDestroy)?.onDestroy();
    }

    super.remove();
  }
}
